<template>
  <div v-loading="loading">
    <nav
      class="navbar-public"
      role="navigation"
      aria-label="main navigation"
    >
      <div class="container">
        <router-link to="/">
          <img
            src="/img/devloc-logo-white.svg"
            :alt="$laravel.app.name + ' logo'"
          >
        </router-link>

        <v-auth-dropdown />
      </div>
    </nav>
    <div>
      <div style="margin-top: 3.5rem;" />

      <slot name="body" />
    </div>
  </div>
</template>


<script>

import AuthDropdown from "./AuthDropdown.vue";

export default {
  metaInfo() {
    return {
      titleTemplate:  "%s - " + this.$laravel.app.name,
      lang: this.$laravel.app.locale
    };
  },
  components: {
    "v-auth-dropdown": AuthDropdown
  },
  props: {
    loading: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      menuIsOpened: false
    };
  },
  watch: {
    "$route.path" () {
      this.menuIsOpened = false;
      document.documentElement.classList.remove("is-no-scroll");
    }
  },
  beforeDestroy() {
    this.closeMenu();
  },
  methods: {
    openMenu() {
      this.menuIsOpened = true;
      document.documentElement.classList.add("is-no-scroll");
    },
    closeMenu() {
      this.menuIsOpened = false;
      document.documentElement.classList.remove("is-no-scroll");
    }
  }
};
</script>

<style lang="scss">
.navbar-public {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: #131627;
  padding: 0 1.5rem;
  height: 3.5rem;
}

.navbar-public .container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 3.5rem;
  color: white;
}

.navbar-public .login-button  {
  color: white !important;
}

.navbar-public .avatar  {
  color: white !important;
}

.navbar-public .avatar .has-text-grey {
  color: white !important;
}

.navbar-public img {
  height: 2.5rem;
}

</style>

